import 'core-js/fn/array/includes';
import 'core-js/fn/array/find-index';
import 'core-js/fn/array/fill';
import 'core-js/fn/array/from';
import '@babel/polyfill';



// WEBPACK FOOTER //
// ./src/polyfills.js